import { FC } from "react";

import { PillBanner } from "./PillBanner";
import { PillBannerButton } from "./PillBannerButton";

import { serverEndSession } from "api/api-server-actions";
import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { InPersonIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { selectActiveClassSessionId, selectCurrentClassUserId } from "store/selectors";
import { useClassActions } from "utils/class-utils";
import { useFollow } from "utils/hooks/use-follow";

interface JoinInPersonClassButtonProps {
  isInstructor?: boolean;
}

export const JoinInPersonClassButton: FC<JoinInPersonClassButtonProps> = ({
  isInstructor = false,
}) => {
  const classSessionId = useAppSelector(selectActiveClassSessionId);
  const currentClassUserId = useAppSelector(selectCurrentClassUserId);
  const { joinClass } = useClassActions();
  const { maybeStartFollowing } = useFollow();

  const onJoinClass = () => {
    joinClass();
    maybeStartFollowing();
  };

  const endInPersonSession = () => {
    if (!classSessionId) return;
    serverEndSession(classSessionId);
  };

  if (!currentClassUserId) {
    return null;
  }

  return (
    <PillBanner
      buttonChildren={
        isInstructor ? (
          <>
            <PillBannerButton
              eventName="Enter class"
              kind="blue"
              title={t("footer.join_session")}
              onClick={onJoinClass}
            >
              {t("footer.join_session")}
            </PillBannerButton>
            <PillBannerButton
              className="border border-red-tint-70 bg-red-tint-99"
              eventName="End Class for All"
              title={t("av.stop_virtual_class_short")}
              onClick={endInPersonSession}
            >
              {t("av.stop_virtual_class_short")}
            </PillBannerButton>
          </>
        ) : (
          <PillBannerButton
            eventName="Enter class"
            kind="blue"
            title={t("footer.join_session")}
            onClick={onJoinClass}
          >
            {t("footer.join_session")}
          </PillBannerButton>
        )
      }
      kind="blue"
      textChildren={
        <IconText
          iconStart={<InPersonIcon className="text-blue-shade-40" />}
          text={t("footer.in_person_class_in_session")}
          truncateText
        />
      }
    />
  );
};
